import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import ControlLeft from './components/control-left.vue';
import ListTable from './components/list-table.vue';
import { getDevicesTypes, getDevicesSummary } from '@blade-sxp/pass/api/access-management/device-management';
import { isEmpty, map } from 'lodash';
let default_1 = class default_1 extends Vue {
    deviceTypeList = [];
    groupId = '';
    deviceId = '';
    deviceSummary = {
        offlineDeviceCnt: 0,
        onlineDeviceCnt: 0,
        unusualDeviceCnt: 0,
    };
    refreshSummary() {
        this.getDevicesSummary();
    }
    getDevicesTypes() {
        getDevicesTypes().then((resp) => {
            this.deviceTypeList = map(resp.data.data, (item, index) => ({ ...item, status: true }));
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    getDevicesSummary() {
        getDevicesSummary().then((resp) => {
            let res = resp.data.data;
            if (!isEmpty(res)) {
                this.deviceSummary = res;
            }
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    mounted() {
        this.getDevicesTypes();
        this.getDevicesSummary();
    }
    changeStatus(item, index) {
        Vue.set(this.deviceTypeList, index, { ...this.deviceTypeList[index], status: !item.status });
    }
    getroupId(e) {
        this.groupId = e;
    }
    initI18n() {
        // this.getDevicesTypes();
    }
    handleClick() {
        const query = this.$route.query;
        const { deviceId = '1362693570728841241' } = query;
        // this.$router.push({ path: '/traffic/device/syncDetail', query: { deviceId: deviceId } });
        this.$router.push({ path: '/traffic/device/detail', query: { deviceId: deviceId } });
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'passList',
        components: { ControlLeft, ListTable },
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
